var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchedule = function SvgSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "schedule_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#schedule_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.902 5.845V6.546h-.6V5.063h.6v.782Zm9.186 1.104v-.804h.92v2.188H5.993V6.145h.92v.804h1.378v-.804h2.961v.804h1.378v-.804h3.08v.804h1.378ZM5.995 17.986h12.01V8.934H5.995v9.052ZM12 10.78a2.681 2.681 0 0 1 2.678 2.678A2.681 2.681 0 0 1 12 16.138a2.681 2.681 0 0 1-2.678-2.679A2.681 2.681 0 0 1 12 10.781Zm.3 2.517h.922v.6H11.7v-2.025h.6v1.425Zm4.4-8.235h-.6v1.483h.6V5.063Zm-5.06 0h.6v1.483h-.6V5.063Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "schedule_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgSchedule as ReactComponent };